<template>
  <div>
    <v-card flat class="mb-5">
      <v-card-text class="black--text">
        <v-container class="pa-5">
          <h2>Informasi Verval Data</h2>
          <v-row class="mt-3">
            <v-col class="py-0 my-1" cols="12" md="6">
              <span class="grey--text text--darken-1">Informasi Dinas</span>
              <v-list-item class="px-0">
                <v-list-item-avatar color="secondary">
                  <v-icon dark>mdi-hospital-building</v-icon>
                </v-list-item-avatar>
                <v-list-item-content class="py-0">
                  <span class="info--text mb-0" style="font-size: 17px">
                    {{ $getDeepObj(pspPeringkat, 'instansi.m_kota.keterangan') }}
                  </span>
                  <div class="mt-1 mb-0">
                    <strong>{{ $getDeepObj(pspPeringkat, 'instansi.m_propinsi.keterangan') || '-' }}</strong>
                  </div>
                </v-list-item-content>
              </v-list-item>
            </v-col>
            <v-col class="py-0 my-1" cols="12" md="6">
              <span class="grey--text text--darken-1">Nama Admin Dinas</span>
              <v-list-item class="px-0">
                <v-list-item-avatar color="secondary">
                  <v-icon dark>mdi-account</v-icon>
                </v-list-item-avatar>
                <v-list-item-content class="py-0">
                  <span class="info--text mb-0" style="font-size: 17px">
                    {{ $getDeepObj(akun, 'nama') }}
                  </span>
                  <div class="mt-1 mb-0"> <strong>Email</strong> {{ $getDeepObj(akun, 'email') }} </div>
                </v-list-item-content>
              </v-list-item>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
    </v-card>
    <v-card>
      <v-card-text>
        <v-container class="pa-5">
          <v-alert type="info" text class="mb-5">
            <span class="black--text">
              Silakan lakukan verval pada data yang ditampilkan berikut dengan kondisi terkini pada sekolah terkait
            </span>
          </v-alert>
          <v-list three-line>
            <v-list-item dense class="px-0">
              <v-list-item-avatar color="secondary">
                <v-icon dark>mdi-account</v-icon>
              </v-list-item-avatar>
              <v-list-item-content>
                <v-row no-gutters>
                  <v-col class="py-0 my-1" cols="12" md="9">
                    <v-row>
                      <v-col cols="12" md="4">
                        <span class="info--text mb-0" style="font-size: 17px">{{ ptkKasek.nama || '-' }}</span>
                        <div class="mt-1 mb-0"> <strong>No UKG:</strong> {{ ptkKasek.no_ukg || '-' }} </div>
                        <div class="mt-1">
                          <v-icon color="success" small dark> mdi-whatsapp </v-icon>
                          {{ ptkKasek.no_hp || '-' }}
                        </div>
                        <div class="mt-3">
                          <div class="body-2 grey--text text--darken-1">Hasil Penilaian</div>
                          <div class="black--text mt-1">
                            <strong>Simulasi Mengajar: </strong>{{ kandidat.nilai_sm || '-' }}
                          </div>
                          <div class="black--text mt-1">
                            <strong>Wawancara: </strong>{{ kandidat.nilai_ww || '-' }}
                          </div>
                        </div>
                      </v-col>
                      <v-col cols="12" md="4">
                        <span class="body-2 grey--text text--darken-1">Jenis PTK</span>
                        <div :class="[isTidakValidPtk ? 'red--text' : '', 'mt-1', 'mb-3']">
                          {{ $getDeepObj(ptkKasek, 'm_jenis_ptk.jenis_ptk') || '-' }}
                        </div>
                        <span class="body-2 grey--text text--darken-1">Tugas Tambahan</span>
                        <div :class="[isTidakValidTugas ? 'red--text' : '', 'mt-1', 'mb-3']">
                          {{ $getDeepObj(ptkTugas, 'm_tugas.keterangan') || '-' }}
                        </div>
                        <span class="body-2 grey--text text--darken-1">Status Keaktifan</span>
                        <div :class="[isTidakValidKeaktifan ? 'red--text' : '', 'mt-1']">
                          {{ $getDeepObj(ptkKasek, 'ptk_sekolah.m_keluar.keterangan') || 'Aktif' }}
                        </div>
                      </v-col>
                      <v-col cols="12" md="4">
                        <span class="body-2 grey--text text--darken-1">Status Kandidat</span>
                        <div>
                          <v-icon color="info" small dark style="margin-bottom: 3px"> mdi-account </v-icon>
                          <span class="body-2 font-weight-medium black--text">
                            {{
                              Number($getDeepObj(kandidat, 'psp_profil.is_cadangan') || 0) > 0
                                ? `Akselerasi ${$getDeepObj(kandidat, 'psp_profil.is_cadangan')}`
                                : 'Reguler'
                            }}
                          </span>
                        </div>
                        <div v-if="+kandidat.is_prioritas === 1" class="orange--text text--darken-3">
                          <v-icon color="info" small dark style="margin-bottom: 3px"> mdi-crown </v-icon> Prioritas
                          diterima
                        </div>
                        <div class="mt-3">
                          <span class="body-2 grey--text text--darken-1">Status Kepegawaian</span>
                          <div>{{ $getDeepObj(ptkKasek, 'm_pegawai.keterangan') || '-' }}</div>
                        </div>
                        <span class="body-2 grey--text text--darken-1">Status Lulus PPPK 2021</span>
                        <div class="mt-1 mb-3">
                          {{ +kandidat.is_lulus_p3k_2021 === 1 ? 'Lulus' : '-' }}
                        </div>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col cols="12" md="3">
                    <v-row>
                      <v-col class="py-0" cols="12">
                        <div v-if="!validasi" class="mt-1">
                          <v-alert class="mt-3" color="orange darken-4" text dense>
                            <v-checkbox class="mt-0" v-model="isCheckedPtk" hide-details>
                              <template v-slot:label>
                                <div class="black--text body-2">
                                  Centang pada bagian ini jika data KS sudah sesuai
                                </div>
                              </template>
                            </v-checkbox>
                          </v-alert>
                        </div>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-list-item-content>
            </v-list-item>
            <v-divider class="mt-5 mb-4" />
            <v-list-item dense class="px-0">
              <v-list-item-avatar color="secondary">
                <v-icon dark>mdi-home</v-icon>
              </v-list-item-avatar>
              <v-list-item-content class="py-0">
                <v-row no-gutters>
                  <v-col cols="12" lg="9">
                    <v-row>
                      <v-col cols="12" lg="4">
                        <span class="body-2 grey--text">Informasi Sekolah</span>
                        <div class="mt-1">
                          <span class="mb-0" style="font-size: 17px">{{ sekolahBertugas.nama }} </span>
                        </div>
                        <div class="mt-1 mb-0"> <strong>NPSN:</strong> {{ sekolahBertugas.npsn }} </div>
                        <div class="mt-1 mb-0">
                          <strong>Status:</strong>
                          {{ Number(sekolahBertugas.is_negeri) === 1 ? 'Negeri' : 'Swasta' }}
                        </div>
                      </v-col>
                      <v-col cols="12" lg="8">
                        <span class="body-2 grey--text">Alamat Sekolah</span>
                        <div class="mt-1">
                          <strong>Provinsi:</strong> {{ $getDeepObj(sekolahBertugas, 'm_propinsi.keterangan') }}
                        </div>
                        <div class="mt-1 mb-0">
                          <strong>Kab / Kota:</strong> {{ $getDeepObj(sekolahBertugas, 'm_kota.keterangan') }}
                        </div>
                        <div class="mt-1 mb-0"> <strong>Alamat:</strong> {{ sekolahBertugas.alamat }} </div>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col cols="12" lg="3">
                    <div v-if="!validasi" class="mt-1">
                      <v-alert class="mt-3" color="orange darken-4" text dense>
                        <v-checkbox class="mt-0" v-model="isCheckedSekolah" hide-details>
                          <template v-slot:label>
                            <div class="black--text body-2">
                              Centang pada bagian ini jika data sekolah sudah sesuai
                            </div>
                          </template>
                        </v-checkbox>
                      </v-alert>
                    </div>
                  </v-col>
                </v-row>
              </v-list-item-content>
            </v-list-item>
          </v-list>
          <v-alert class="mt-3" color="yellow" text>
            <h4 class="black--text">Pilih Hasil Verval</h4>
            <div v-if="validasi" class="mt-1 mb-2 black--text">
              <span class="red--text font-weight-medium">Keterangan: </span> {{ validasi }}
            </div>
            <div class="mt-1">
              <v-btn
                :disabled="!!validasi"
                :outlined="form.k_verval_peringkat_psp !== 2"
                :dark="form.k_verval_peringkat_psp === 2"
                depressed
                color="green"
                class="mr-2"
                @click="onSetSesuai"
              >
                <v-icon left>mdi-check</v-icon> Data sudah sesuai
              </v-btn>
              <v-btn
                :outlined="form.k_verval_peringkat_psp !== 3"
                :dark="form.k_verval_peringkat_psp === 3"
                depressed
                color="red"
                class="mr-2"
                @click="form.k_verval_peringkat_psp = 3"
              >
                <v-icon left>mdi-close</v-icon> Diskualifikasi
              </v-btn>
              <v-btn
                :outlined="form.k_verval_peringkat_psp !== 4"
                :dark="form.k_verval_peringkat_psp === 4"
                depressed
                color="orange"
                @click="form.k_verval_peringkat_psp = 4"
              >
                <v-icon left>mdi-pencil</v-icon> Proses Perbaikan
              </v-btn>
            </div>
          </v-alert>
          <v-row v-if="[3, 4].includes(form.k_verval_peringkat_psp)">
            <v-col v-if="form.k_verval_peringkat_psp === 3" cols="12" lg="6">
              <span class="px-0 body-2 grey--text text--darken-1" style="height: 24px">
                Pilih alasan diskualifikasi <span class="red--text">*</span>
              </span>
              <v-select
                v-model="form.catatan_verval"
                placeholder="Pilih alasan diskualifikasi"
                :items="listAlasan"
                dense
                outlined
                hide-details
              />
            </v-col>
            <v-col v-if="form.k_verval_peringkat_psp === 3" cols="12" lg="6">
              <span class="px-0 body-2 grey--text text--darken-1" style="height: 24px">
                Unggah dokumen pendukung <span class="red--text">*</span>
              </span>
              <v-file-input
                v-model="form.file"
                :accept="['application/pdf,image/*']"
                outlined
                dense
                hide-details
                prepend-icon=""
                @click:append="onHandleClickAppend"
                :ref="`vFileInput`"
                append-icon="mdi-paperclip"
                placeholder="pilih dokumen (maks 1MB)"
              />
            </v-col>
            <v-col
              v-if="
                (form.k_verval_peringkat_psp === 3 && form.catatan_verval === 'Alasan lainnya') ||
                  form.k_verval_peringkat_psp === 4
              "
              cols="12"
            >
              <span class="px-0 body-2 grey--text text--darken-1" style="height: 24px">
                Tuliskan alasan {{ form.k_verval_peringkat_psp === 3 ? 'diskualifikasi lainnya' : 'proses perbaikan' }}
                <span class="red--text">*</span>
              </span>
              <v-textarea
                rows="2"
                outlined
                :placeholder="
                  `Tuliskan alasan lainnya untuk ${
                    form.k_verval_peringkat_psp === 3 ? 'diskualifikasi' : 'proses perbaikan data'
                  } kandidat`
                "
                v-model="form.catatan_verval_lain"
              ></v-textarea>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
    </v-card>
  </div>
</template>
<script>
import { mapState } from 'vuex';
export default {
  props: {
    kandidat: {
      type: Object,
      default: () => {},
    },
    validasi: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      isCheckedPtk: false,
      isCheckedSekolah: false,
      form: { k_verval_peringkat_psp: '' },
      listAlasan: [
        'Lulus PPPK',
        'Promosi',
        'Menjadi Guru',
        'Mutasi (ke sekolah bukan pelaksana PSP atau lembaga lain)',
        'Mengundurkan diri',
        'Meninggal dunia',
        'Pensiun',
        'Alasan lainnya',
      ],
    };
  },
  computed: {
    ...mapState('preferensi', {
      akun: (state) => Object.assign({}, state.data && state.data.akun),
    }),

    ...mapState('peringkat', {
      pspPeringkat: (state) => state.psp_peringkat || {},
    }),

    ptkKasek() {
      return this.kandidat.ptk_kasek || {};
    },

    ptkTugas() {
      return this.$getDeepObj(this.kandidat, 'ptk_kasek.ptk_tugases.0') || {};
    },

    sekolahBertugas() {
      return this.$getDeepObj(this.kandidat, 'ptk_kasek.ptk_tugases.0.sekolah') || {};
    },

    isTidakValidKeaktifan() {
      return !!(this.$getDeepObj(this.ptkKasek, 'ptk_sekolah.k_keluar') || '');
    },

    isTidakValidTugas() {
      return this.ptkTugas.k_tugas !== 2;
    },

    isTidakValidPtk() {
      return ![20, 57].includes(this.ptkKasek.k_jenis_ptk);
    },
  },

  methods: {
    reset() {
      this.$set(this, 'isCheckedPtk', false);
      this.$set(this, 'isCheckedSekolah', false);
      this.$set(this, 'form', { k_verval_peringkat_psp: '' });
    },

    getValue() {
      return this.form;
    },

    onHandleClickAppend() {
      this.$refs[`vFileInput`][0].$el.querySelector('input').click();
    },

    onSetSesuai() {
      if (!this.isCheckedPtk || !this.isCheckedSekolah) {
        this.$error(
          'Pastikan Anda telah melakukan pengecekan data di atas dan menyatakan data yang tampil sudah sesuai'
        );
        this.form.k_verval_peringkat_psp = null;
        return;
      }

      this.form.k_verval_peringkat_psp = 2;
    },

    onChangeStatus() {
      this.form.k_verval_peringkat_psp = this.isCheckedPtk && this.isCheckedSekolah ? 2 : '';
    },
  },

  watch: {
    isCheckedPtk: 'onChangeStatus',
    isCheckedSekolah: 'onChangeStatus',
  },
};
</script>
